import AdminDashboard from '../pages/admin/Dashboard';
import Dashboard1 from '../pages/admin/Dashboard1';
import Dashboard2 from '../pages/admin/Dashboard2';
import Dashboard3 from '../pages/admin/Dashboard3';
import Student from '../pages/admin/Student';
import UserAccounts from "../pages/admin/UserAccounts";
import PaidFees from "../pages/admin/PaidFees";

import Coach from '../pages/admin/Coach';
import Principle from '../pages/admin/Principle';
import Book from '../pages/admin/Book';
import Session from '../pages/admin/Session';
import Attendance from '../pages/admin/Attendance';
import ApplicationForm from "../pages/admin/ApplicationForm";

//TOURNAMENT PARTICIPANTS PAGE
import TournamentParticipants from "../pages/admin/TournamentParticipants";
import ProfitLoss from "../pages/admin/ProfitLoss";

const adminRoutes = [
  { path: 'dashboard', element: <AdminDashboard /> },
  { path: 'dashboard1', element: <Dashboard1 /> },
  { path: 'dashboard2', element: <Dashboard2 /> },
  { path: 'dashboard3', element: <Dashboard3 /> },
  { path: 'student', element: <Student /> },
  { path: 'user-accounts', element: <UserAccounts /> },
   { path: 'fee-receipts', element: <PaidFees /> },

  { path: 'coaches', element: <Coach /> },
  { path: 'principle', element: <Principle /> },
  { path: 'book', element: <Book /> },
  { path: 'session', element: <Session /> },
  { path: 'Attendance', element: <Attendance /> },
  { path: 'application-form', element: <ApplicationForm /> },

    // ================= TOURNAMENT PARTICIPANTS =================
  { 
    path: 'tournaments/participants', 
    element: <TournamentParticipants /> 
  },
  { 
  path: 'tournaments/profit-loss', 
  element: <ProfitLoss /> 
},

];

export default adminRoutes;
